import React, { useEffect, useState } from "react";
import axios from "axios";

const VehiclesSection = ({ empresaId }: { empresaId: number }) => {
  const BASE_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}` };

  // Lista de modelos com capacidades (string, para bater com newVehicle)
  const predefinedModels = [
    { label: "Piaggio", capacity: "3-4" },
    { label: "Tuk Tuk (newer)", capacity: "5" },
    { label: "Tuk Tuk (older, e.g., 2014/2015)", capacity: "7" },
    { label: "Quad", capacity: "4-6" },
    { label: "Calhambeque", capacity: "5-8" },
    { label: "Piaggio (diesel or converted electric)", capacity: "5-7" },
  ];


  // Estado com os campos corretos e tipos coerentes
  const [vehicles, setVehicles] = useState<any[]>([]);
  const [showForm, setShowForm] = useState(false);
  const [empresaStatus, setEmpresaStatus] = useState<"PENDENTE" | "APROVADA" | "REJEITADA" | null>(null);
  const [motivoRejeicao, setMotivoRejeicao] = useState<string | null>(null);
  const [empresaLoading, setEmpresaLoading] = useState(true);

  const [selectedModel, setSelectedModel] = useState("");
  const [customModel, setCustomModel] = useState("");
  const [newVehicle, setNewVehicle] = useState({
    modelo: "",
    placa: "",
    capacidade: "",
    cor: "",
    fotoId: null,
    livreteId: null,
    seguroId: null,
    licencaRnaatId: null,
    seguroOcupantesId: null,
    // 🔹 Campos do livrete
    numeroMatricula: "",
    dataEmissao: "",
    dataFabricacao: "",
    numeroChassi: "",
    // 🔹 Campos do seguro
    numeroApolice: "",
    nomeAssegurador: "",
    nomeSeguradora: "",
    dataEmissaoSeguro: "",
    dataTerminoSeguro: "",
    // 🔹 Licença RNAAT
    numeroLicencaRnaat: "",
    // 🔹 Seguro de ocupantes
    numeroApoliceOcupantes: "",
    nomeAsseguradorOcupantes: "",
    nomeSeguradoraOcupantes: "",
    dataEmissaoSeguroOcupantes: "",
    dataTerminoSeguroOcupantes: "",
  });

  const [editId, setEditId] = useState<number | null>(null);

  const [editVehicle, setEditVehicle] = useState({
    modelo: "",
    placa: "",
    capacidade: "",
    cor: "",
    fotoId: null,
    fotoUrl: "",
    livreteId: null,
    livreteUrl: "",
    seguroId: null,
    seguroUrl: "",
    licencaRnaatId: null,
    licencaRnaatUrl: "",
    seguroOcupantesId: null,
    seguroOcupantesUrl: "",
    // 🔹 Campos do livrete
    numeroMatricula: "",
    dataEmissao: "",
    dataFabricacao: "",
    numeroChassi: "",
    // 🔹 Campos do seguro
    numeroApolice: "",
    nomeAssegurador: "",
    nomeSeguradora: "",
    dataEmissaoSeguro: "",
    dataTerminoSeguro: "",
    // 🔹 Licença RNAAT
    numeroLicencaRnaat: "",
    // 🔹 Seguro de ocupantes
    numeroApoliceOcupantes: "",
    nomeAsseguradorOcupantes: "",
    nomeSeguradoraOcupantes: "",
    dataEmissaoSeguroOcupantes: "",
    dataTerminoSeguroOcupantes: "",
  });

  const [errors, setErrors] = useState<any>({});

  // Carregar veículos
  const loadVehicles = () => {
    axios
      .get(`${BASE_URL}/empresas/${empresaId}/veiculos`, { headers })
      .then((res) => setVehicles(res.data))
      .catch(() => alert("Failed to load vehicles."));
  };

  useEffect(() => {
    // Buscar status de aprovação da empresa
    axios.get(`${BASE_URL}/empresas/minha`, { headers })
      .then((res) => {
        setEmpresaStatus(res.data.status); // "PENDENTE", "APROVADA", "REJEITADA"
        setMotivoRejeicao(res.data.motivoRejeicao || null);
      })
      .catch((err) => {
        console.error("Erro ao carregar status da empresa", err);
      })
      .finally(() => {
        setEmpresaLoading(false);
      });
  }, []);

  useEffect(() => {
    if (empresaId) {
      loadVehicles();
    }
  }, [empresaId]);

  const validate = () => {
    const err: any = {};

    // Campos de texto obrigatórios
    if (!newVehicle.modelo) err.modelo = "Modelo é obrigatório.";
    if (!newVehicle.placa) err.placa = "Placa é obrigatória.";
    if (!newVehicle.capacidade) err.capacidade = "Capacidade é obrigatória.";
    if (!newVehicle.cor) err.cor = "Cor é obrigatória.";

    // Arquivos obrigatórios
    if (!newVehicle.fotoId) err.fotoId = "Foto do veículo é obrigatória.";
    if (!newVehicle.livreteId) err.livreteId = "Livrete é obrigatório.";
    if (!newVehicle.seguroId) err.seguroId = "Seguro é obrigatório.";
    if (!newVehicle.licencaRnaatId) err.licencaRnaatId = "Licença RNAAT é obrigatória.";
    if (!newVehicle.seguroOcupantesId) err.seguroOcupantesId = "Seguro de ocupantes é obrigatório.";

    return err;
  };

  // Função para upload de arquivos que retorna ID (e não URL)
  const handleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    field: keyof typeof newVehicle
  ) => {
    if (!e.target.files?.[0]) return;
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(`${BASE_URL}/uploads`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      // Aqui salvamos o ID do arquivo (res.data.id) e não a URL
      setNewVehicle((prev) => ({ ...prev, [field]: res.data.id }));
    } catch {
      alert("Erro no upload do arquivo");
    }
  };

  const handleFileChangeEdit = async (
    e: React.ChangeEvent<HTMLInputElement>,
    field: keyof typeof editVehicle
  ) => {
    if (!e.target.files?.[0]) return;
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await axios.post(`${BASE_URL}/uploads`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setEditVehicle((prev) => ({ ...prev, [field]: res.data.id }));
    } catch {
      alert("Erro no upload do arquivo");
    }
  };

  const handleAdd = () => {
    const err = validate();

    // Validação extra para custom model
    if (selectedModel === "Other" && !customModel.trim()) {
      err.modelo = "Please enter a model name.";
    }

    setErrors(err);
    if (Object.keys(err).length > 0) return;

    axios
      .post(`${BASE_URL}/empresas/${empresaId}/veiculos`, newVehicle, { headers })
      .then(() => {
        loadVehicles();
        // Reset do formulário incluindo todos os campos
        setNewVehicle({
          modelo: "",
          placa: "",
          capacidade: "",
          cor: "",
          fotoId: null,
          livreteId: null,
          seguroId: null,
          licencaRnaatId: null,
          seguroOcupantesId: null,
          // Campos do livrete
          numeroMatricula: "",
          dataEmissao: "",
          dataFabricacao: "",
          numeroChassi: "",
          // Campos do seguro
          numeroApolice: "",
          nomeAssegurador: "",
          nomeSeguradora: "",
          dataEmissaoSeguro: "",
          dataTerminoSeguro: "",
          // Licença RNAAT
          numeroLicencaRnaat: "",
          // Seguro de ocupantes
          numeroApoliceOcupantes: "",
          nomeAsseguradorOcupantes: "",
          nomeSeguradoraOcupantes: "",
          dataEmissaoSeguroOcupantes: "",
          dataTerminoSeguroOcupantes: "",
        });
        setShowForm(false);
        setErrors({});
        alert("Vehicle added successfully.");
      })
      .catch(() => alert("Error while saving vehicle."));
  };

  const handleDelete = (id: number) => {
    if (!window.confirm("Are you sure you want to delete this vehicle?")) return;

    axios
      .delete(`${BASE_URL}/empresas/veiculos/${id}`, { headers })
      .then(() => {
        loadVehicles();
        alert("Vehicle deleted successfully.");
      })
      .catch(() => alert("Error while deleting vehicle."));
  };

  const handleUpdate = (id: number) => {
    const payload = { ...editVehicle };

    axios
      .put(`${BASE_URL}/empresas/veiculos/${id}`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(() => {
        loadVehicles();
        setEditId(null);
        alert("Veículo atualizado com sucesso.");
      })
      .catch(() => alert("Erro ao atualizar o veículo."));
  };

  return (
    <div className="settings-content mt-3">
      <h6 className="fs-16 mb-3">Vehicles</h6>

      {/* Banner informativo se empresa não aprovada */}
      {empresaLoading ? (
        <div className="alert alert-info">Checking company status...</div>
      ) : empresaStatus === "APROVADA" ? (
        <div className="alert alert-success">Approved company — you can register vehicles.</div>
      ) : empresaStatus === "REJEITADA" ? (
        <div className="alert alert-danger">
          Company REJECTED — registration blocked. <br />
          <strong>Reason:</strong> {motivoRejeicao || "No reason provided."}
          Go to the company information page (on the dashboard: settings {">"} company info) to update your data and send it for review again.
        </div>
      ) : (
        <div className="alert alert-warning">
          Company pending approval — driver and vehicle registration is blocked.
        </div>
      )}

      <button
        className="btn btn-sm btn-outline-primary mb-3"
        onClick={() => {
          if (empresaLoading) {
            alert("Verificando status da empresa. Aguarde...");
            return;
          }
          if (empresaStatus === "REJEITADA") {
            alert(`Sua empresa foi rejeitada. Motivo: ${motivoRejeicao || "Motivo não informado"}`);
            return;
          }
          if (empresaStatus !== "APROVADA") {
            alert("Sua empresa ainda não foi aprovada. Não é possível adicionar veículos.");
            return;
          }
          setShowForm((s) => !s);
        }}
        disabled={empresaLoading || empresaStatus !== "APROVADA"}
        title={
          empresaLoading
            ? "Verificando status da empresa..."
            : empresaStatus === "APROVADA"
              ? "Adicionar veículo"
              : empresaStatus === "REJEITADA"
                ? "Sua empresa foi rejeitada"
                : "Sua empresa ainda não está aprovada"
        }
      >
        {showForm ? "Cancel" : "Add Vehicle"}
      </button>

      {showForm && (
        <div className="card p-3 mb-4">
          <div className="row g-3">
            {/* Model (special case) */}
            <div className="col-md-6">
              <label className="form-label">Model</label>
              <select
                className={`form-select ${errors.modelo ? "is-invalid" : ""}`}
                value={selectedModel}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedModel(value);

                  const modelObj = predefinedModels.find(m => m.label === value);
                  if (modelObj) {
                    setNewVehicle(prev => ({
                      ...prev,
                      capacidade: modelObj.capacity,
                      modelo: modelObj.label
                    }));
                  } else if (value === "Other") {
                    setNewVehicle(prev => ({
                      ...prev,
                      capacidade: "",
                      modelo: ""
                    }));
                    setCustomModel("");
                  }
                }}
              >
                <option value="" disabled>Select a model</option>
                {predefinedModels.map(m => (
                  <option key={m.label} value={m.label}>
                    {m.label} ({m.capacity} people)
                  </option>
                ))}
                <option value="Other">Other</option>
              </select>
              {errors.modelo && <div className="invalid-feedback">{errors.modelo}</div>}
            </div>

            {/* Custom input if "Other" */}
            {selectedModel === "Other" && (
              <div className="col-md-6">
                <label className="form-label">Custom Model</label>
                <input
                  type="text"
                  className={`form-control ${errors.modelo ? "is-invalid" : ""}`}
                  placeholder="Type your model"
                  value={customModel}
                  onChange={(e) => {
                    const value = e.target.value;
                    setCustomModel(value);
                    setNewVehicle(prev => ({ ...prev, modelo: value }));
                  }}
                />
              </div>
            )}

            {/* Capacity (auto filled but editable) */}
            <div className="col-md-6">
              <label className="form-label">Capacity (people, including driver)</label>
              <input
                type="text"
                className={`form-control ${errors.capacidade ? "is-invalid" : ""}`}
                value={newVehicle.capacidade}
                onChange={(e) =>
                  setNewVehicle({ ...newVehicle, capacidade: e.target.value })
                }
              />
              {errors.capacidade && <div className="invalid-feedback">{errors.capacidade}</div>}
            </div>

            {/* Other fields */}
            {[
              { label: "License Plate", key: "placa", type: "text" },
              { label: "Color", key: "cor", type: "text" },
              { label: "Registration Number", key: "numeroMatricula", type: "text" },
              { label: "Issue Date", key: "dataEmissao", type: "date" },
              { label: "Manufacturing Date", key: "dataFabricacao", type: "date" },
              { label: "Chassis Number", key: "numeroChassi", type: "text" },
              { label: "Insurance Policy Number", key: "numeroApolice", type: "text" },
              { label: "Insured Name", key: "nomeAssegurador", type: "text" },
              { label: "Insurance Company", key: "nomeSeguradora", type: "text" },
              { label: "Insurance Start Date", key: "dataEmissaoSeguro", type: "date" },
              { label: "Insurance End Date", key: "dataTerminoSeguro", type: "date" },
              { label: "RNAAT License Number", key: "numeroLicencaRnaat", type: "text" },
              { label: "Passenger Insurance Policy", key: "numeroApoliceOcupantes", type: "text" },
              { label: "Passenger Insured Name", key: "nomeAsseguradorOcupantes", type: "text" },
              { label: "Passenger Insurance Company", key: "nomeSeguradoraOcupantes", type: "text" },
              { label: "Passenger Insurance Start Date", key: "dataEmissaoSeguroOcupantes", type: "date" },
              { label: "Passenger Insurance End Date", key: "dataTerminoSeguroOcupantes", type: "date" },
            ].map(({ label, key, type }) => (
              <div className="col-md-6" key={key}>
                <label className="form-label">{label}</label>
                <input
                  type={type}
                  className={`form-control ${errors[key] ? "is-invalid" : ""}`}
                  value={newVehicle[key as keyof typeof newVehicle] || ""}
                  onChange={(e) =>
                    setNewVehicle({ ...newVehicle, [key]: e.target.value })
                  }
                />
                {errors[key] && <div className="invalid-feedback">{errors[key]}</div>}
              </div>
            ))}

            {/* Uploads */}
            {[
              { label: "Vehicle Photo", key: "fotoId" },
              { label: "Registration Document", key: "livreteId" },
              { label: "Insurance", key: "seguroId" },
              { label: "RNAAT License", key: "licencaRnaatId" },
              { label: "Passenger Insurance", key: "seguroOcupantesId" },
            ].map(({ label, key }) => (
              <div className="col-md-6" key={key}>
                <label className="form-label">{label}</label>
                <input
                  type="file"
                  className={`form-control ${errors[key] ? "is-invalid" : ""}`}
                  accept="image/*,application/pdf"
                  onChange={(e) => handleFileChange(e, key as keyof typeof newVehicle)}
                />
                {newVehicle[key as keyof typeof newVehicle] && (
                  <small className="text-success">File uploaded.</small>
                )}
                {errors[key] && <div className="invalid-feedback">{errors[key]}</div>}
              </div>
            ))}

            {/* Save Button */}
            <div className="col-12 text-end">
              <button className="btn btn-success" onClick={handleAdd}>
                Save Vehicle
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Vehicles list */}
      <div className="row">
        {vehicles.length > 0 ? (
          vehicles.map((v) => (
            <div className="col-md-6 mb-3" key={v.id}>
              <div className="card h-100">
                <div className="card-body">
                  {editId === v.id ? (
                    <>
                      {/* Grouped Sections */}
                      <h6 className="mt-2">Vehicle Information</h6>
                      <div className="row">
                        {[
                          { label: "Model", key: "modelo", type: "text" },
                          { label: "Plate", key: "placa", type: "text" },
                          { label: "Capacity", key: "capacidade", type: "number" },
                          { label: "Color", key: "cor", type: "text" },
                        ].map(({ label, key, type }) => (
                          <div className="col-md-6 mb-2" key={key}>
                            <label className="form-label">{label}</label>
                            <input
                              type={type}
                              className="form-control"
                              value={editVehicle[key as keyof typeof editVehicle] || ""}
                              onChange={(e) =>
                                setEditVehicle({ ...editVehicle, [key]: e.target.value })
                              }
                            />
                          </div>
                        ))}
                      </div>

                      <h6 className="mt-3">Vehicle Registration (Livrete)</h6>
                      <div className="row">
                        {[
                          { label: "Registration Number", key: "numeroMatricula", type: "text" },
                          { label: "Issue Date", key: "dataEmissao", type: "date" },
                          { label: "Manufacture Date", key: "dataFabricacao", type: "date" },
                          { label: "Chassis Number", key: "numeroChassi", type: "text" },
                        ].map(({ label, key, type }) => (
                          <div className="col-md-6 mb-2" key={key}>
                            <label className="form-label">{label}</label>
                            <input
                              type={type}
                              className="form-control"
                              value={editVehicle[key as keyof typeof editVehicle] || ""}
                              onChange={(e) =>
                                setEditVehicle({ ...editVehicle, [key]: e.target.value })
                              }
                            />
                          </div>
                        ))}
                      </div>

                      <h6 className="mt-3">Insurance</h6>
                      <div className="row">
                        {[
                          { label: "Policy Number", key: "numeroApolice", type: "text" },
                          { label: "Insurer Name", key: "nomeAssegurador", type: "text" },
                          { label: "Insurance Company", key: "nomeSeguradora", type: "text" },
                          { label: "Issue Date", key: "dataEmissaoSeguro", type: "date" },
                          { label: "Expiry Date", key: "dataTerminoSeguro", type: "date" },
                        ].map(({ label, key, type }) => (
                          <div className="col-md-6 mb-2" key={key}>
                            <label className="form-label">{label}</label>
                            <input
                              type={type}
                              className="form-control"
                              value={editVehicle[key as keyof typeof editVehicle] || ""}
                              onChange={(e) =>
                                setEditVehicle({ ...editVehicle, [key]: e.target.value })
                              }
                            />
                          </div>
                        ))}
                      </div>

                      <h6 className="mt-3">RNAAT License</h6>
                      <div className="row">
                        <div className="col-md-6 mb-2">
                          <label className="form-label">License Number</label>
                          <input
                            type="text"
                            className="form-control"
                            value={editVehicle.numeroLicencaRnaat || ""}
                            onChange={(e) =>
                              setEditVehicle({ ...editVehicle, numeroLicencaRnaat: e.target.value })
                            }
                          />
                        </div>
                      </div>

                      <h6 className="mt-3">Occupants Insurance</h6>
                      <div className="row">
                        {[
                          { label: "Policy Number", key: "numeroApoliceOcupantes", type: "text" },
                          { label: "Insurer Name", key: "nomeAsseguradorOcupantes", type: "text" },
                          { label: "Insurance Company", key: "nomeSeguradoraOcupantes", type: "text" },
                          { label: "Issue Date", key: "dataEmissaoSeguroOcupantes", type: "date" },
                          { label: "Expiry Date", key: "dataTerminoSeguroOcupantes", type: "date" },
                        ].map(({ label, key, type }) => (
                          <div className="col-md-6 mb-2" key={key}>
                            <label className="form-label">{label}</label>
                            <input
                              type={type}
                              className="form-control"
                              value={editVehicle[key as keyof typeof editVehicle] || ""}
                              onChange={(e) =>
                                setEditVehicle({ ...editVehicle, [key]: e.target.value })
                              }
                            />
                          </div>
                        ))}
                      </div>

                      <h6 className="mt-3">Uploads</h6>
                      <div className="row">
                        {[
                          { label: "Vehicle Photo", key: "foto" },
                          { label: "Registration Document", key: "livrete" },
                          { label: "Insurance", key: "seguro" },
                          { label: "RNAAT License", key: "licencaRnaat" },
                          { label: "Occupants Insurance", key: "seguroOcupantes" },
                        ].map(({ label, key }) => {
                          const idKey = `${key}Id` as keyof typeof editVehicle;
                          const urlKey = `${key}Url` as keyof typeof editVehicle;
                          const url = editVehicle[urlKey];

                          return (
                            <div className="col-md-6 mb-2" key={key}>
                              <label className="form-label">{label}</label>
                              <input
                                type="file"
                                className="form-control"
                                accept="image/*,application/pdf"
                                onChange={(e) => handleFileChangeEdit(e, idKey)}
                              />

                              {!editVehicle[idKey] && url && (
                                <div style={{ marginTop: "5px" }}>
                                  {url.endsWith(".pdf") ? (
                                    <a href={`${BASE_URL}${url}`} target="_blank" rel="noopener noreferrer">
                                      View PDF
                                    </a>
                                  ) : (
                                    <img
                                      src={`${BASE_URL}${url}`}
                                      alt={label}
                                      style={{
                                        maxWidth: "150px",
                                        marginTop: "5px",
                                        borderRadius: "6px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  )}
                                </div>
                              )}

                              {editVehicle[idKey] && (
                                <small className="text-success">New file selected.</small>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </>
                  ) : (
                    <>
                      <h6>{v.modelo}</h6>
                      <p className="mb-1"><strong>Plate:</strong> {v.placa}</p>
                      <p className="mb-1"><strong>Capacity:</strong> {v.capacidade}</p>
                      <p className="mb-1"><strong>Color:</strong> {v.cor}</p>

                      {/* Status */}
                      <p className="mb-1">
                        <strong>Status:</strong>{" "}
                        {v.status === "APROVADO" && <span className="text-success">Approved</span>}
                        {v.status === "REJEITADO" && <span className="text-danger">Rejected</span>}
                        {v.status === "PENDENTE" && <span className="text-warning">Under Review</span>}
                      </p>

                      {/* Rejection Reason */}
                      {v.status === "REJEITADO" && v.motivoReprovacao && (
                        <p className="text-danger mb-1">
                          <strong>Reason:</strong> {v.motivoReprovacao}
                        </p>
                      )}

                      {v.fotoUrl && (
                        <img
                          src={`${BASE_URL}${v.fotoUrl}`}
                          alt="photo"
                          style={{
                            maxWidth: "250px",
                            height: "auto",
                            marginTop: "10px",
                            borderRadius: "8px",
                            objectFit: "contain"
                          }}
                        />
                      )}
                    </>
                  )}
                </div>
                <div className="card-footer text-end">
                  {editId === v.id ? (
                    <>
                      <button
                        className="btn btn-sm btn-success me-2"
                        onClick={() => handleUpdate(v.id)}
                      >
                        Save
                      </button>
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => setEditId(null)}
                      >
                        Cancel
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => {
                          setEditId(v.id);
                          setEditVehicle({
                            modelo: v.modelo || "",
                            placa: v.placa || "",
                            capacidade: v.capacidade || "",
                            cor: v.cor || "",
                            fotoId: null,
                            fotoUrl: v.fotoUrl || "",
                            livreteId: null,
                            livreteUrl: v.livreteUrl || "",
                            seguroId: null,
                            seguroUrl: v.seguroUrl || "",
                            licencaRnaatId: null,
                            licencaRnaatUrl: v.licencaRnaatUrl || "",
                            seguroOcupantesId: null,
                            seguroOcupantesUrl: v.seguroOcupantesUrl || "",
                            // Campos do livrete
                            numeroMatricula: v.numeroMatricula || "",
                            dataEmissao: v.dataEmissao || "",
                            dataFabricacao: v.dataFabricacao || "",
                            numeroChassi: v.numeroChassi || "",
                            // Campos do seguro
                            numeroApolice: v.numeroApolice || "",
                            nomeAssegurador: v.nomeAssegurador || "",
                            nomeSeguradora: v.nomeSeguradora || "",
                            dataEmissaoSeguro: v.dataEmissaoSeguro || "",
                            dataTerminoSeguro: v.dataTerminoSeguro || "",
                            // Licença RNAAT
                            numeroLicencaRnaat: v.numeroLicencaRnaat || "",
                            // Seguro de ocupantes
                            numeroApoliceOcupantes: v.numeroApoliceOcupantes || "",
                            nomeAsseguradorOcupantes: v.nomeAsseguradorOcupantes || "",
                            nomeSeguradoraOcupantes: v.nomeSeguradoraOcupantes || "",
                            dataEmissaoSeguroOcupantes: v.dataEmissaoSeguroOcupantes || "",
                            dataTerminoSeguroOcupantes: v.dataTerminoSeguroOcupantes || "",
                          });
                        }}
                      >
                        Edit
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(v.id)}
                      >
                        Delete
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No vehicles registered yet.</p>
        )}
      </div>
    </div>
  );
};

export default VehiclesSection;